module.exports = __webpack_public_path__ + "static/media/4.405042c7.jpg";